<template>
  <div class="loading">
    <svg width="80px" height="80px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/spiner" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Rectangle" fill-opacity="0" fill="#FFFFFF" x="0" y="0" width="80" height="80"></rect>
        <path d="M8.66611154,17.7744642 L7.27723524,20.1800685 L8.66611154,17.7744642 Z M15.3338885,6.2255358 L16.7459581,3.77975941 L15.3338885,6.2255358 Z M17.7744642,8.66611154 L20.2202406,7.25404188 L17.7744642,8.66611154 Z M6.2255358,15.3338885 L3.81993149,16.7227648 L6.2255358,15.3338885 Z M15.3338885,17.7744642 L16.7459581,20.2202406 L15.3338885,17.7744642 Z M8.66611154,6.2255358 L7.27723524,3.81993149 L8.66611154,6.2255358 Z M17.7744642,15.3338885 L20.2202406,16.7459581 L17.7744642,15.3338885 Z M6.2255358,8.66611154 L3.81993149,7.27723524 L6.2255358,8.66611154 Z M12,18.7004395 L12,21.4919162 L12,18.7004395 Z M12,2.55447049 L12,5.34472656 L12,2.55447049 Z M18.723877,12 L21.4919162,12 L18.723877,12 Z M2.55447049,12 L5.32836914,12 L2.55447049,12 Z" id="Path-2" stroke="#252525" stroke-linecap="round" stroke-linejoin="round"></path>
      </g>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'LoadingSpinner',
  components: {},
  props: {},

};

</script>

<style scoped lang="scss">
    .loading {
      margin: 20% auto;
      width: 80px;
      height: 80px;
      -webkit-animation-name: spin;
      -webkit-animation-duration: 2000ms;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-timing-function: linear;
      -moz-animation-name: spin;
      -moz-animation-duration: 2000ms;
      -moz-animation-iteration-count: infinite;
      -moz-animation-timing-function: linear;
      -ms-animation-name: spin;
      -ms-animation-duration: 2000ms;
      -ms-animation-iteration-count: infinite;
      -ms-animation-timing-function: linear;
      animation-name: spin;
      animation-duration: 2000ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

    @-ms-keyframes spin {
      from {
        -ms-transform: rotate(0deg);
      }
      to {
        -ms-transform: rotate(360deg);
      }
    }

    @-moz-keyframes spin {
      from {
        -moz-transform: rotate(0deg);
      }
      to {
        -moz-transform: rotate(360deg);
      }
    }

    @-webkit-keyframes spin {
      from {
        -webkit-transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(360deg);
      }
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

</style>
